import { useEffect } from "react";
import { trackOutboundPortalClick } from "@/lib/analytics";

const INTERNAL_HOSTS = ["gewerbeflaeche-mieten.de", "www.gewerbeflaeche-mieten.de", "localhost"];

const portalNameFromHost = (host: string) =>
  host.replace(/^www\./, "").replace(/\.(de|com|eu|net|org|at|ch)$/, "");

/**
 * Delegated listener that fires the GA4 "outbound_portal_click" event for every
 * click on an external link. Mounted once at app level.
 */
export const OutboundLinkTracker = () => {
  useEffect(() => {
    const handler = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null;
      const anchor = target?.closest?.("a") as HTMLAnchorElement | null;
      if (!anchor?.href) return;

      let url: URL;
      try {
        url = new URL(anchor.href, window.location.origin);
      } catch {
        return;
      }
      if (!url.protocol.startsWith("http")) return;

      const host = url.hostname.toLowerCase();
      const isInternal =
        host === window.location.hostname ||
        INTERNAL_HOSTS.includes(host) ||
        host.endsWith(".lovable.app") ||
        host.endsWith(".lovableproject.com");
      if (isInternal) return;

      trackOutboundPortalClick(portalNameFromHost(host), window.location.pathname);
    };

    document.addEventListener("click", handler, { capture: true });
    return () => document.removeEventListener("click", handler, { capture: true });
  }, []);

  return null;
};
